import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AppThunk } from "./store";
import { getOrgId } from "./orgHelpers";
import { PurchaseService } from "../services/PurchaseService";
import { formatGetTodayDate } from "../utils/format";
import { IPurchase, Purchase, PurchaseStatus } from "../models/Purchase";
import { OperationStatus } from "../models/Transactions";

interface PurchaseSate {
    purchasesToday: Array<any>;
    purchasesTodayByOrganization: Array<any>;
    purchasesList: Array<IPurchase> | null;
    modalAddPurchaseStatus: boolean,
    loadingResults: boolean,
    profitList: Array<any> | null
}

const initialState: PurchaseSate = {
    purchasesToday: [],
    purchasesTodayByOrganization: [],
    purchasesList: null,
    modalAddPurchaseStatus: false,
    loadingResults: false,
    profitList: null
};

const purchasesSlice = createSlice({
    name: 'purchases',
    initialState,
    reducers: {
        setPurchasesToday : (state, action: PayloadAction<Array<any>>) => {
            state.purchasesToday = action.payload;
        },
        setPurchaseByOrganizationByDate: (state, action: PayloadAction<Array<any>>) => {
            state.purchasesTodayByOrganization = action.payload;
        },
        setPurchasesList: (state, action: PayloadAction<Array<any>>) => {
            state.purchasesList = action.payload;
        },
        setModalAddPurchaseStatus: (state, action: PayloadAction<boolean>) => {
            state.modalAddPurchaseStatus = action.payload;
        },
        setLoadingResults: (state, action: PayloadAction<boolean>) => {
            state.loadingResults = action.payload;
        },
        setProfitList: (state, action: PayloadAction<Array<any>>) => {
            state.profitList = action.payload;
        },
    }
  });
  
export const {
    setPurchasesToday, 
    setPurchaseByOrganizationByDate,
    setPurchasesList,
    setModalAddPurchaseStatus,
    setLoadingResults,
    setProfitList
} = purchasesSlice.actions;

// customs func
const getPurchasesByType = (type:String) : AppThunk<Promise<void>> => async (dispatch, getState) => {



}

export const getPurchasesToday = () : AppThunk<Promise<void>> => async (dispatch, getState) => {
    const today = formatGetTodayDate();
    try {
        const purchaseResponse : Array<any> = await PurchaseService.getAllPurchaseToday(today);
        dispatch(setPurchasesToday(purchaseResponse))
    } catch (e) {
        console.error('error')
    }
}

export const fetchPurchasesByOrganizationToday = (id:number, isFromToday?:boolean) : AppThunk<Promise<void>> => async (dispatch, getState) => {
    const today = formatGetTodayDate();
    try {
        let purchaseResponse: Array<any> ;
        if (isFromToday) {
            purchaseResponse = await PurchaseService.getPurchasesByOrganizationToday(id,today);
        } else {
            purchaseResponse = await PurchaseService.getPurchasesByOrganizationToday(id);
        }
        dispatch(setPurchaseByOrganizationByDate(purchaseResponse))
    } catch (e) {
        console.error('error')
    }
}

export const fetchPurchases = () : AppThunk<Promise<void>> => async (dispatch, getState) => {
    const state = getState();
    const id = getOrgId(state);
    try {
        const purchaseResponse : Array<any> = await PurchaseService.getPurchasesByOrganization(id);
        dispatch(setPurchasesList(purchaseResponse))
    } catch (e) {
        console.error('error')
    }
}

export const  addPurchase = (payload:Purchase): AppThunk<Promise<void>> => async (dispatch, getState) => {

    const state = getState();
    const id = getOrgId(state);

    payload.organization_id = id;
    payload.status = OperationStatus.WAITING;
    
    try {
        const purchaseResponse : Array<any> = await PurchaseService.createPurchase(payload);
    } catch (e) {
        console.error('error')
    } finally {
        dispatch( setModalAddPurchaseStatus(false))
        dispatch( fetchPurchases())
    }
}

export const updatePurchase = (payload:any): AppThunk<Promise<void>> => async (dispatch, getState) => {

    try {
        const purchaseResponse : any = await PurchaseService.updatePurchase(payload);
        if (!purchaseResponse) throw new Error('Erro ao tentar fazer update')
    } catch (e) {
        console.error('error')
    } finally {
        dispatch( setLoadingResults(false))
        dispatch( fetchPurchases())
    }
}

export const fetchProfits = (range?: { date_start?: string; date_end?: string }): AppThunk<Promise<void>> => async (dispatch, getState) => {
    try {
        const id = getOrgId(getState());
        const profitList : any = await PurchaseService.fetchProfits(id, false, range);
        dispatch( setProfitList(profitList))
    } catch (e) {
        console.error(e)
    } 
}


export default purchasesSlice.reducer;